"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * BonusX - Auth Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationApi = exports.AuthenticationApiFactory = exports.AuthenticationApiFp = exports.AuthenticationApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
exports.AuthenticationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary User can login through SSI qrcode
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin: (inlineObject, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/adminLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationValidateGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: (inputChangePassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inputChangePassword, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistingEmail: (inputCheckExistingEmail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/check-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inputCheckExistingEmail, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbilityRules: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/ability-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPassword: (authenticationBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/login/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(authenticationBody, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary User can login through SSI qrcode
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicLogin: (inlineObject1, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/magicLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: (inputAuthenticationRegister, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inputAuthenticationRegister, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForgotPasswordEmail: (inputSendForgotPasswordEmail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/send-forgot-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inputSendForgotPasswordEmail, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/authentication/verify-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication cookieAuth required
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
exports.AuthenticationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthenticationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary User can login through SSI qrcode
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin(inlineObject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLogin(inlineObject, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationValidateGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authenticationValidateGet(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(inputChangePassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changePassword(inputChangePassword, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistingEmail(inputCheckExistingEmail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkExistingEmail(inputCheckExistingEmail, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbilityRules(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAbilityRules(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPassword(authenticationBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginWithPassword(authenticationBody, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logout(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary User can login through SSI qrcode
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicLogin(inlineObject1, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.magicLogin(inlineObject1, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(inputAuthenticationRegister, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.register(inputAuthenticationRegister, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForgotPasswordEmail(inputSendForgotPasswordEmail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendForgotPasswordEmail(inputSendForgotPasswordEmail, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccount(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyAccount(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AuthenticationApi - factory interface
 * @export
 */
exports.AuthenticationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthenticationApiFp(configuration);
    return {
        /**
         *
         * @summary User can login through SSI qrcode
         * @param {InlineObject} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLogin(inlineObject, options) {
            return localVarFp.adminLogin(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * Use this endpoint to check if the user is authenticated.
         * @summary Check user authentication status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationValidateGet(options) {
            return localVarFp.authenticationValidateGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User can change password and login
         * @param {InputChangePassword} [inputChangePassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(inputChangePassword, options) {
            return localVarFp.changePassword(inputChangePassword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InputCheckExistingEmail} [inputCheckExistingEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkExistingEmail(inputCheckExistingEmail, options) {
            return localVarFp.checkExistingEmail(inputCheckExistingEmail, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User can load ability rules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAbilityRules(options) {
            return localVarFp.getAbilityRules(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User can login through email and password
         * @param {AuthenticationBody} [authenticationBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPassword(authenticationBody, options) {
            return localVarFp.loginWithPassword(authenticationBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Logout from bonusx
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options) {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User can login through SSI qrcode
         * @param {InlineObject1} [inlineObject1]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        magicLogin(inlineObject1, options) {
            return localVarFp.magicLogin(inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Registration with email and password
         * @param {InputAuthenticationRegister} [inputAuthenticationRegister]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(inputAuthenticationRegister, options) {
            return localVarFp.register(inputAuthenticationRegister, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User can request an email to change their password
         * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendForgotPasswordEmail(inputSendForgotPasswordEmail, options) {
            return localVarFp.sendForgotPasswordEmail(inputSendForgotPasswordEmail, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccount(options) {
            return localVarFp.verifyAccount(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
class AuthenticationApi extends base_1.BaseAPI {
    /**
     *
     * @summary User can login through SSI qrcode
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    adminLogin(inlineObject, options) {
        return exports.AuthenticationApiFp(this.configuration).adminLogin(inlineObject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Use this endpoint to check if the user is authenticated.
     * @summary Check user authentication status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authenticationValidateGet(options) {
        return exports.AuthenticationApiFp(this.configuration).authenticationValidateGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User can change password and login
     * @param {InputChangePassword} [inputChangePassword]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    changePassword(inputChangePassword, options) {
        return exports.AuthenticationApiFp(this.configuration).changePassword(inputChangePassword, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InputCheckExistingEmail} [inputCheckExistingEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    checkExistingEmail(inputCheckExistingEmail, options) {
        return exports.AuthenticationApiFp(this.configuration).checkExistingEmail(inputCheckExistingEmail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User can load ability rules
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    getAbilityRules(options) {
        return exports.AuthenticationApiFp(this.configuration).getAbilityRules(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User can login through email and password
     * @param {AuthenticationBody} [authenticationBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    loginWithPassword(authenticationBody, options) {
        return exports.AuthenticationApiFp(this.configuration).loginWithPassword(authenticationBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Logout from bonusx
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    logout(options) {
        return exports.AuthenticationApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User can login through SSI qrcode
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    magicLogin(inlineObject1, options) {
        return exports.AuthenticationApiFp(this.configuration).magicLogin(inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Registration with email and password
     * @param {InputAuthenticationRegister} [inputAuthenticationRegister]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    register(inputAuthenticationRegister, options) {
        return exports.AuthenticationApiFp(this.configuration).register(inputAuthenticationRegister, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User can request an email to change their password
     * @param {InputSendForgotPasswordEmail} [inputSendForgotPasswordEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    sendForgotPasswordEmail(inputSendForgotPasswordEmail, options) {
        return exports.AuthenticationApiFp(this.configuration).sendForgotPasswordEmail(inputSendForgotPasswordEmail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify current account by passing a token provided through a verified email, if verified is redirected to /verify-email app page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    verifyAccount(options) {
        return exports.AuthenticationApiFp(this.configuration).verifyAccount(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthenticationApi = AuthenticationApi;
